export const DEFAULT_BBOX = [[51.089062, 9.55932], [41.33374, -5.1406]];

export const MESSAGE_EXAMPLE = `Machine C02
Operationnelle

+42.234563+12.243847
`;

export const BEGIN_YEAR = 2016;
export const END_YEAR = 2017;

export const JUSTIFICATION_ITEMS = [
  'Garage',
  'Non utilisé',
  'ATI en panne',
  'Autres'
];

export const CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS = {
  'Garage': 'j-s-garage',
  'Non utilisé': 'j-s-not-used',
  'ATI en panne': 'j-s-broken',
  'Autres': 'j-s-other'
};

export const MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre'
];



// WEBPACK FOOTER //
// ./src/config.js